import { useSyncExternalStore } from 'react';

// Tiny shared store: the bottom bar (FieldTabBar on the legacy UI, MainTabBar
// otherwise) publishes its rendered height (0 when hidden) so root-level
// overlays like the sync banner can sit above it.
// Context is not usable here because those overlays render outside the
// navigation tree that hosts the tab bar.
let currentHeight = 0;
const listeners = new Set();

export const setFieldTabBarHeight = (height) => {
	const nextHeight = height || 0;
	if (nextHeight === currentHeight) {
		return;
	}

	currentHeight = nextHeight;
	listeners.forEach(listener => listener());
};

const subscribe = (listener) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};

export const getFieldTabBarHeight = () => currentHeight;

export const useFieldTabBarHeight = () => useSyncExternalStore(subscribe, getFieldTabBarHeight);
